export default __webpack_public_path__ + "static/media/iconCategoria.b3495e5c.svg";